<ngx-ui-loader></ngx-ui-loader>
<!-- chatbot start -->
<app-chatbot-component></app-chatbot-component>
<!-- chatbot end -->
<!-- FOOTER - STARTS -->
<footer> 
    <section class="footer">
        <div class="container-xxl">
            <div class="footer-link-box">
                <div class="row" >
                    <div class="col-lg-4-5 mb-xl-0 mb-3" *ngFor="let loopGlobalFooter of footerGlobalMenu" >
                        <h3 class="footer-heading screen-reader" *ngIf="language=='English'">{{loopGlobalFooter["menuNameInEnglish"]}}</h3>
                        <h3 class="footer-heading screen-reader" *ngIf="language=='Hindi'">{{loopGlobalFooter["menuNameInHindi"]}}</h3>
                        <div class="row gy-1 mt-2 mt-md-3 mt-lg-2 mt-xl-3 footer-link" *ngIf="language=='English'">
                            <ng-container *ngFor="let loopPrimaryFooter of footerPrimaryMenu">
                                <ng-container *ngIf='loopGlobalFooter["id"] == loopPrimaryFooter["globalMenu"]'>
                                    <div class="col-lg-6 col-md-6 col-sm-6">

                                        <!-- For External Page-->
                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==1' href="javascript:void(0);"
                                            [title]='loopPrimaryFooter["menuNameInEnglish"]'
                                            (click)='goToExtLink(loopPrimaryFooter["externalLink"])'><span>{{loopPrimaryFooter["menuNameInEnglish"]}}</span></a>
                                        <!-- End of External Page  -->
                                       
                                        <!-- For Plugin Page-->
                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==2' href="javascript:void(0);" (click)="goToPluginPage(loopPrimaryFooter['selectPlugin'],{'plugin_id':loopPrimaryFooter['id'],'selectPlugin':loopPrimaryFooter['selectPlugin']})"
                                            [title]='loopPrimaryFooter["menuNameInEnglish"]'><span>{{loopPrimaryFooter["menuNameInEnglish"]}}</span></a>
                                        <!-- End of Plugin Page  -->

                                        <!-- For Content Page-->

                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==3' href="javascript:void(0);"
                                            [title]='loopPrimaryFooter["menuNameInEnglish"]'
                                            (click)="goToContentPage(loopPrimaryFooter)"><span>{{loopPrimaryFooter["menuNameInEnglish"]}}</span></a>

                                        <!-- End of Content Page  -->


                                    </div>
                                </ng-container>
                            </ng-container>
                           
                        </div>
                        <div class="row gy-1 mt-2 mt-md-3 mt-lg-2 mt-xl-3 footer-link" *ngIf="language=='Hindi'">
                            <ng-container *ngFor="let loopPrimaryFooter of footerPrimaryMenu">
                                <ng-container *ngIf='loopGlobalFooter["id"] == loopPrimaryFooter["globalMenu"]'>
                                    <div class="col-lg-6 col-md-6 col-sm-6">

                                        <!-- For External Page-->
                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==1' href="javascript:void(0);"
                                            [title]='loopPrimaryFooter["menuNameInHindi"]'
                                            (click)='goToExtLink(loopPrimaryFooter["externalLink"])'><span>{{loopPrimaryFooter["menuNameInHindi"]}}</span></a>
                                        <!-- End of External Page  -->
                                       
                                        <!-- For Plugin Page-->
                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==2' href="javascript:void(0);" (click)="goToPluginPage(loopPrimaryFooter['selectPlugin'],{'plugin_id':loopPrimaryFooter['id'],'selectPlugin':loopPrimaryFooter['selectPlugin']})"
                                            [title]='loopPrimaryFooter["menuNameInHindi"]'><span>{{loopPrimaryFooter["menuNameInHindi"]}}</span></a>
                                        <!-- End of Plugin Page  -->

                                        <!-- For Content Page-->

                                        <a class="screen-reader" *ngIf='loopPrimaryFooter["linkType"] ==3' href="javascript:void(0);"
                                            [title]='loopPrimaryFooter["menuNameInHindi"]'
                                            (click)="goToContentPage(loopPrimaryFooter)"><span>{{loopPrimaryFooter["menuNameInHindi"]}}</span></a>

                                        <!-- End of Content Page  -->


                                    </div>
                                </ng-container>
                            </ng-container>
                           
                        </div>
                    </div>


 
                  
                    <div class="col-lg-3-5">
                        <h3 class="footer-heading screen-reader">
                            {{"Address" | translate}}
                        </h3>
                        <div class="row gy-1 mt-2 mt-md-3 mt-lg-2 mt-xl-3 ">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                                <p class="screen-reader">
                                    {{language=='English'?zoneDetails.address:zoneDetails.addressInHindi}}
                                </p>

                                <div class="address-details">
                                    <div class="help-desk">
                                        <i class="icon-fci-help-desk"></i>
                                    </div>
                                    <div class="screen-reader">
                                       <p>{{ 'Helpdesk' |  translate}}</p>
                                        <h5>{{zoneDetails.helpdeskNumber}}</h5>
                                    </div>
                                </div> 

                                <div class="address-details mt-2">
                                    <div class="feedback">
                                        <i class="icon-fci-feedback"></i>
                                    </div>
                                    <div class="screen-reader">
                                        <p>{{ 'Feedback' |  translate}}</p>
                                        <a href="mailto:{{zoneDetails.feedbackEmailId}}" [attr.title]="language=='English'?'E-mail':'ई-मेल'">{{zoneDetails.feedbackEmailId}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="container-xxl">
            <div class="copy-right-box">
                <div class="row align-items-center ">
                    <div class="col-lg-12 col-xl-6 col-md-12 text-center text-xl-start text-md-center">
                        <div class="d-flex flex-column flex-sm-row gap-1 gap-sm-3 align-items-center justify-content-center justify-content-xl-start">
                            <a title="STQC Certification" target="_blank" href="assets/stqc/FCI_STQC_2024-05-24.pdf">
                                <img src="assets/images/stqc-logo.png" alt="stqc-certification" width="50">
                            </a>
                            <span class="border-end border-height"></span>
                            <span class="copy-right-text screen-reader">&#64;{{  FooterYear | date:'yyyy'}} {{ 'footeCopyright' | translate}}</span>
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-6 col-md-12 ">
                        <div
                            class="d-block d-md-flex d-lg-flex align-items-center justify-content-xl-end justify-content-md-center footer-Analytic">
                            <ul class="d-flex justify-content-around align-items-center gap-3 m-0 p-0">
                                <li class="screen-reader">
                                    {{ 'VisitorNo'| translate }} <span class="visitor-count">{{ visito_no }}</span>
                                </li>
                                <li class="screen-reader">
                                    {{ 'LastUpdatedon'|translate  }}: <span class="last-upt">{{ lastUpdatedata.stmUpdatedOn | date: 'd MMM y'}},  {{ update_time | timeFormat}}</span>
                                </li>
                            </ul>
                            <span class="border-end border-height"></span>
                            <ul
                                class="d-flex justify-content-center justify-content-sm-center align-items-center gap-3 m-0 p-0">
                                <li class="screen-reader">{{ 'FollowUs'|translate }}:</li>
                                <a class="screen-reader" href="https://www.facebook.com/FoodCorporation" target="_blank" data-bs-toggle="tooltip" [attr.title]="language=='English'?'Facebook':'फेसबुक'"><li class="social-icon"><i
                                        class="bi bi-facebook"></i></li></a>
                                <a class="screen-reader" href="https://twitter.com/FCI_India" target="_blank" data-bs-toggle="tooltip" [attr.title]="language=='English'?'Twitter':'ट्विटर'"><li class="social-icon"><i
                                        class="icon-fci-twitter-x"></i></li></a>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>
</footer>
<!-- FOOTER - ENDS -->

<!-- SCROLL TO TOP - STARTS -->
<div title="Scroll To Top" class="to-top" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
    <i class="bi bi-arrow-up"></i>
</div>
<!-- SCROLL TO TOP - ENDS -->
